import { getCurrentProject } from '@common/modules/projects/stores/projects.actions'
import { useProjectsStore } from '@common/modules/projects/stores/projects.store'
import { updateLastUsedProject } from '@common/modules/workspaces/stores/workspaces.actions'
import type { Workspace } from '@common/modules/workspaces/types'

function shouldQueueLastUsedSync(workspace: Workspace, currentProjectId: string | undefined): boolean {
  if (currentProjectId != null) {
    return workspace.lastUsedProjectId !== currentProjectId
  }
  return Boolean(workspace.lastUsedProjectId)
}

/**
 * Resolves the current project for the workspace, then queues a non-blocking last-used sync when needed.
 */
export async function resolveWorkspaceProjectAndSyncLastUsed(workspace: Workspace): Promise<void> {
  await getCurrentProject(workspace.id)

  const currentProject = useProjectsStore.getState().currentProject
  const projectIdToPersist = currentProject?.id ?? workspace.lastUsedProjectId
  if (!projectIdToPersist) {
    return
  }

  if (shouldQueueLastUsedSync(workspace, currentProject?.id)) {
    updateLastUsedProject(workspace.id, projectIdToPersist)
  }
}
